import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';

import { PlantillaNotificacionCorreoDto } from '../../../dto/plantilla-notificacion-correo/plantilla-notificacion-correo.dto';
import { PlantillasCorreoService } from '../../../services/plantillas-correo.service';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import {TranslateService} from "@ngx-translate/core";
import { Jodit } from 'jodit';
import { NotificationService } from '../../../services/notification.service';


@Component({
  selector: 'app-gestion-plantillas-correo',
  templateUrl: './gestion-plantillas-correo.component.html',
  styleUrl: './gestion-plantillas-correo.component.scss',
})
export class GestionPlantillasCorreoComponent implements OnInit {
  templates: PlantillaNotificacionCorreoDto[] = [];
  selectedTemplate: PlantillaNotificacionCorreoDto | null = null;
  editableCuerpoPlantilla = '';
  selectedTemplateId: number | null = null;
  variablesArray: string[] = [];
  @ViewChild('editorContainer', { static: false }) editorContainer!: ElementRef;
  private editor!: any;

  editorConfig: any = {
    height: 500,
    events: {
      afterInit: (editor: any) => {
        let lastTableHTML = "";

        editor.events.on("change", () => {
          const table = editor.container.querySelector("table");
          if (table) {
            lastTableHTML = table.outerHTML;
          }
        });

        editor.events.on("keydown", (event: KeyboardEvent) => {
          let selection = editor.selection.current() as HTMLElement | null;

          if (event.key === "Backspace" || event.key === "Delete") {
            let parentTable = selection?.closest("table");

            if (parentTable) {
              const hasContent = parentTable.innerText.trim().length > 0;

              if (hasContent && !selection?.closest("td, th")) {
                event.preventDefault();
                event.stopPropagation();
                return false;
              }
            }
          }

          return true;
        });


        editor.events.on("afterCommand", (command: string) => {
          setTimeout(() => {
            const currentTable = editor.container.querySelector("table");

            if (!currentTable && lastTableHTML) {
              const tempDiv = document.createElement("div");
              tempDiv.innerHTML = lastTableHTML;
              const savedTable = tempDiv.querySelector("table");

              if (savedTable && savedTable.innerText.trim().length > 0) {
                editor.selection.insertHTML(lastTableHTML);
              }
            }
          }, 100);
        });
      }
    }
  };

  // Multilenguaje
  plantillaText: any = {};
  constructor(
    private readonly plantillasService: PlantillasCorreoService,
    private readonly alertService: AlertaModalService,
    private readonly translate: TranslateService,
    private notificationService: NotificationService,
  ) {}

  ngOnInit(): void {
    this.cargarPlantillas();
    this.translate.stream('gestion-plantillas').subscribe(text => {
      this.plantillaText = text;
    });
  }

  cargarPlantillas(): void {
    this.plantillasService.obtenerPlantillas().subscribe(
      response => {
        this.templates = response;
        if (this.templates.length > 0) {
          this.selectedTemplateId = this.templates[0].Id;
          this.onTemplateChange();
        }
      },
      error => {
        return;
      }
    );
  }

  onTemplateChange(): void {
    this.selectedTemplate =
      this.templates.find(template => template.Id == this.selectedTemplateId) ||
      null;
    this.updateEditableCuerpo();
    this.updateVariables();
  }

  updateVariables(): void {
    // Obtener y procesar la propiedad "Variables"
    const variablesString = this.selectedTemplate?.Variables || '';
    this.variablesArray = variablesString
      .split(',')
      .map(variable => variable.trim())
      .filter(variable => variable)
      .map(variable => `#{${variable}}`);
  }

  updateEditableCuerpo(): void {
    this.editableCuerpoPlantilla = this.selectedTemplate?.Cuerpo_plantilla || '';
  
    // Modificar el contenido para que los <p> tengan color negro
    const cuerpoConEstilo = this.editableCuerpoPlantilla.replace(
      /<p(.*?)>/g,
      '<p$1 style="color: black;">'
    );
  
    setTimeout(() => {
      const editor = document.querySelector('.jodit-wysiwyg');
      if (editor) {
        editor.innerHTML = cuerpoConEstilo;
      }
    }, 100);
  }
  
  
  ngAfterViewInit(): void {
    if (!this.editorContainer) {
      return;
    }
  
    this.editor = new Jodit(this.editorContainer.nativeElement, this.editorConfig);
    this.editor.value = this.editableCuerpoPlantilla;
  
    this.editor.events.on('change', () => {
      this.editableCuerpoPlantilla = this.editor.value;
    });
  }

  saveTemplate(): void {
    if (this.selectedTemplate) {
      const cuerpoPlantilla: string = this.editableCuerpoPlantilla;
      this.plantillasService
        .actualizarPlantilla(this.selectedTemplate.Id, cuerpoPlantilla)
        .subscribe(
          response => {
            if (response.status === 200) {
              this.alertService.exito(this.plantillaText['exito']);
              this.cargarPlantillas();
            }
          },
          error => {
            this.notificationService.addNotification('error', this.plantillaText['error']);
          }
        );
    }
  }
}
